import AuthValidator from '@/utils/validators/domain/Auth'
import { emailEmptyError, emailFormatError, emailLengthError, passwordEmptyError, passwordFormatError, passwordConfirmError } from '@/const/errorMessage'

export interface Fields {
  email: string
  password: string
  passwordConfirm: string
}

export type FieldErrors = { [key in keyof Fields]: string[] }

export default class SignupAccountValidator {
  static validate(fields: Partial<Fields>): FieldErrors {
    const errors: FieldErrors = {
      email: [],
      password: [],
      passwordConfirm: []
    }

    const validator = new AuthValidator(fields)

    if (fields.email !== undefined) {
      if (!fields.email) {
        errors.email.push(emailEmptyError)
      } else {
        if (!validator.isEmailFormatValid()) {
          errors.email.push(emailFormatError)
        }

        if (!validator.isEmailLengthValid()) {
          errors.email.push(emailLengthError)
        }
      }
    }

    if (fields.password !== undefined) {
      if (!fields.password) {
        errors.password.push(passwordEmptyError)
      } else if (!validator.isPasswordFormatValid() || !validator.isPasswordLengthValid()) {
        errors.password.push(passwordFormatError)
      }
    }

    // passwordConfirm専用validation
    if (fields.passwordConfirm !== undefined) {
      if (fields.passwordConfirm) {
        if (fields.passwordConfirm !== fields.password) {
          errors.passwordConfirm.push(passwordConfirmError)
        }
      }
    }

    return errors
  }
}
